import "./PagePanel.css";
import { ReactNode } from "react";

type Props = {
  borderColor?: string;
  className?: string;
  dataCy?: string;
  noBorder?: boolean;
  title?: ReactNode;
  children: ReactNode;
};

export default function PagePanel(props: Props) {
  const borderColor = props.borderColor ? props.borderColor : "#ffc107";

  return (
    <div
      className={(props.className ? props.className + " " : "") + "page-panel"}
      data-cy={props.dataCy}
    >
      {props.title && (
        <div className="title">
          {!props.noBorder && (
            <div
              className="border"
              style={{ borderTop: "4px solid " + borderColor }}
            ></div>
          )}
          {props.title}
        </div>
      )}
      <div className="content">{props.children}</div>
    </div>
  );
}
